export default "__VITE_ASSET__cf879020__"